"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const index_view_1 = __importDefault(require("./index.view"));
function ProductTableTitleSection() {
    const history = (0, react_router_dom_1.useHistory)();
    const onAddRow = react_1.default.useCallback(() => {
        history.push("/products/add-product");
    }, [history]);
    return react_1.default.createElement(index_view_1.default, { onAddRow: onAddRow });
}
exports.default = ProductTableTitleSection;
